export var SubscriptionType;
(function (SubscriptionType) {
    SubscriptionType["User"] = "User";
    SubscriptionType["Business"] = "Business";
})(SubscriptionType || (SubscriptionType = {}));
//# sourceMappingURL=subscription-type.const.js.map